import api from './api'
import type {
  SalaryHistoryCreatePayload,
} from '@/types/payroll'

export const salaryHistoryApi = {
  getAll: (employeeId: number | string, params: Record<string, any> = {}): Promise<any> =>
    api.get(`/employees/${employeeId}/salary-history`, { params }),
  create: (employeeId: number | string, data: SalaryHistoryCreatePayload): Promise<any> =>
    api.post(`/employees/${employeeId}/salary-history`, data),
  salaryAt: (
    employeeId: number | string,
    params: { field: string; date: string },
  ): Promise<any> => api.get(`/employees/${employeeId}/salary-at`, { params }),
}
